// @ts-nocheck


import queryString from 'query-string';


import {
  fetchRequest,
  initialFetchListParams,
  downloadRequestWithToken } from
'./index';

import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { convertDataFromServer as actConvertDataFromServer } from './act';
import { convertDataFromServer as convertDataFromServerGroupedList } from './executionBudget';


export const convertDataFromServer = (
vehicleMonitoring) => (
{
  ...vehicleMonitoring,
  paymentAmount: convertFromKopToRub(vehicleMonitoring.paymentAmount),
  act: vehicleMonitoring.act ?
  actConvertDataFromServer(vehicleMonitoring.act) :
  undefined
});

export const convertDataToServer = (vehicleMonitoring) => ({
  ...vehicleMonitoring,
  paymentAmount: convertFromRubToKop(vehicleMonitoring.paymentAmount)
});

export const getVehicleCount = async () => {
  const count = fetchRequest.get(`/vehicleMonitoring/vehiclesCount`);
  if (count) return count;
  throw new Error('Не удалось получить кол-во ТС');
};

export const addVehicleMonitoring = async (
vehicleMonitoring) =>
{
  const added = await fetchRequest.post(
    '/vehicleMonitoring',
    convertDataToServer(vehicleMonitoring)
  );
  if (added) return added;
  throw new Error('Не удалось создать услугу по мониторингу');
};

export const updateVehicleMonitoring = async (
vehicleMonitoring) =>
{
  const updated = await fetchRequest.put(
    '/vehicleMonitoring',
    convertDataToServer(vehicleMonitoring)
  );
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось обновить услугу по мониторингу');
};
export const deleteVehicleMonitoring = async (
id) =>
{
  const deleted = await fetchRequest.delete(`/vehicleMonitoring/${id}`);
  if (deleted) return convertDataFromServer(deleted);
  throw new Error('Не удалось удалить услугу по мониторингу');
};

export const fetchVehicleMonitoring = async (
id,
params = {}) =>
{
  const vehicleMonitoring = await fetchRequest.get(
    `/vehicleMonitoring/${id}`,
    params
  );
  if (vehicleMonitoring) return convertDataFromServer(vehicleMonitoring);
  throw new Error('Не удалось получить услугу по мониторингу');
};

export const fetchVehicleVehicleMonitorings = async (
vehicleId,
params = initialFetchListParams) =>
{
  const vehicleMonitorings = await fetchRequest.get(
    `/vehicleMonitoring/vehicle/${vehicleId}`,
    {
      ...initialFetchListParams,
      ...params
    }
  );
  if (vehicleMonitorings) {
    return {
      ...vehicleMonitorings,
      data: vehicleMonitorings.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось получить список услуг по мониторингу');
};

export const fetchVehicleMonitorings = async (
params = initialFetchListParams) =>
{
  const vehicleMonitorings = await fetchRequest.get(`/vehicleMonitoring`, {
    ...initialFetchListParams,
    ...params
  });
  if (vehicleMonitorings) {
    return {
      ...vehicleMonitorings,
      data: vehicleMonitorings.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось получить список услуг по мониторингу');
};
export const updateAct = async (
params,
data) =>
{
  const vehicleMonitoring = await fetchRequest.put(
    `/vehicleMonitoring/updateActId?${queryString.stringify(params)}`,
    data
  );
  if (vehicleMonitoring) {
    return {
      ...vehicleMonitoring,
      data: vehicleMonitoring.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось закрепить акт за списоком монторинга ТС');
};

export const getTotalSum = async (params = {}) => {
  const sum = await fetchRequest.get(`/vehicleMonitoring/totalSum`, params);
  if (sum || sum === 0) return convertFromKopToRub(sum);
  throw new Error('Не удалось получить общую сумму');
};

export const groupedList = async (
params = {}) =>
{
  const groupedList = await fetchRequest.get(
    `/vehicleMonitoring/groupedList`,
    params
  );
  if (groupedList)
  return {
    ...groupedList,
    data: groupedList.data.map(convertDataFromServerGroupedList)
  };
  throw new Error(
    'Не удалось получить сгруппированный список для исполнения бюджета'
  );
};

export const printReport = async (
params,
fileName) =>
{
  const isPrinted = await downloadRequestWithToken(
    '/vehicleMonitoring/print',
    params,
    fileName
  );
  if (isPrinted) return true;
  throw new Error('Не удалось загрузить отчет');
};

export default {
  groupedList,
  getTotalSum,
  updateAct,
  getVehicleCount,
  addVehicleMonitoring,
  updateVehicleMonitoring,
  deleteVehicleMonitoring,
  fetchVehicleMonitoring,
  fetchVehicleVehicleMonitorings,
  fetchVehicleMonitorings,
  printReport
};
